import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-[#D2DCEC]" data-id="element-19" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-20" data-mp="22divwowf5p6l">
        <div className="text-center mb-16" data-id="element-21" data-mp="1ydi7qcjipzmc">
          <p className="text-[#7A5C00] font-bold tracking-widest uppercase mb-2" data-id="element-22" data-mp="1yet9k6tekxat">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-[#0B1F4D]" data-id="element-23" data-mp="15pw10vezuev9">
            <span className="text-[#1236C0]" data-id="element-24" data-mp="1jgitw6y2pajf">5</span> EXCLUSIVE ELECTRICAL{' '}
            <span className="text-[#1236C0]" data-id="element-25" data-mp="1jilnt22cjntf">INSTRUCTOR BONUSES</span>
          </h2>
          <p className="text-lg text-slate-700/80 max-w-3xl mx-auto mt-5" data-id="element-26" data-mp="1eny0v7mzr1gy">
            The six main volumes give you visual training material for every core electrical teaching area. And the five
            bonuses add practical tools to help you solve circuits with quick-reference formulas, script your
            demonstrations, assign circuit-building lab projects and wiring exercises, train students to read symbols and
            find faults, and assess them with clear competency checklists, rubrics and certificates.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-27" data-mp="2ofxuesqnfpn7">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-[#D2DCEC] rounded-2xl p-8 shadow-sm shadow-[#0B1F4D]/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="1quaav8fal1t3" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-[#0B1F4D] text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-29" data-mp="3h4llx61zrb97">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-[#E5ECF8] border border-[#F5C400] rounded-full flex items-center justify-center text-[#1236C0] mb-4" data-id="element-30" data-mp="1c53qn8ym2oks">
                <Gift size={24} data-id="element-31" data-mp="1q3aedw9uj86q" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 pr-28 text-[#0B1F4D]" data-id="element-32" data-mp="1m28f5ffxiw4r">{bonus.title}</h3>
              <p className="text-[#7A5C00] text-sm font-semibold mb-4 border-l-4 border-[#F5C400] pl-4" data-id="element-33" data-mp="ydyz6u5ed2lj">
                {bonus.subtitle}
              </p>
              {bonus.referenceValueCents !== undefined && <p className="flex flex-wrap items-baseline gap-x-2 text-sm mb-4" data-id="element-34" data-mp="1760u6cwp5qof">
                  <span className="text-slate-500" data-id="element-35" data-mp="12dg49mgwvxq6">Reference value:</span>
                  <span className="text-slate-500 line-through" data-id="element-36" data-mp="eooh59i6i5k9">
                    {formatUsd(bonus.referenceValueCents)}
                  </span>
                  <span className="font-extrabold text-green-700 uppercase tracking-wide" data-id="element-37" data-mp="amthe9fwc08l">
                    Included free
                  </span>
                </p>}
              {bonus.intro && <p className="text-slate-700 text-sm mb-4 leading-relaxed" data-id="element-38" data-mp="5c7iwcujum0p">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-[#0B1F4D] font-semibold text-sm mb-3" data-id="element-39" data-mp="3rqha0tpv6856">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-40" data-mp="jb793oxpn8yz">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-41" data-mp="e9hvc1j3sh77">
                        <CheckCircle2 size={16} className="text-[#1236C0] shrink-0 mt-0.5" data-id="element-42" data-mp="2u1nwbfr0ts8h" />
                        <span className="text-slate-700 text-sm" data-id="element-43" data-mp="2z1jtav1awjej">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.detailedBullets && <>
                  <p className="text-[#0B1F4D] font-semibold text-sm mb-3" data-id="element-44" data-mp="3ag54jl0020u1">{bonus.bulletsIntro}</p>
                  <ul className="mb-6 space-y-3" data-id="element-45" data-mp="35imz44l6y3qs">
                    {bonus.detailedBullets.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-46" data-mp="30hfnfufxgkeu">
                        <CheckCircle2 size={16} className="text-[#1236C0] shrink-0 mt-0.5" data-id="element-47" data-mp="20v92vqm7tv8" />
                        <div data-id="element-48" data-mp="3t8h6w7qnl246">
                          <span className="block text-[#0B1F4D] font-bold text-sm" data-id="element-49" data-mp="3t63bfxs29nw3">{item.title}</span>
                          <span className="block text-slate-700 text-sm" data-id="element-50" data-mp="3j9s0pc84d63r">{item.detail}</span>
                        </div>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-[#0B1F4D] font-semibold text-sm mb-3" data-id="element-51" data-mp="27wxvu5qepft7">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-52" data-mp="scoxp3lwdz5m">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-[#0B1F4D] font-semibold text-sm bg-[#E5ECF8] border border-[#D2DCEC] rounded-lg px-3 py-2" data-id="element-53" data-mp="x8nhedwa6szp">
                        {bullet}
                      </li>)}
                  </ul>
                  {bonus.secondaryNote && <p className="-mt-3 mb-6 text-slate-700 text-sm italic" data-id="element-54" data-mp="1g2j7fcax77ln">{bonus.secondaryNote}</p>}
                </>}

              <div className="mt-auto space-y-3" data-id="element-55" data-mp="3hskzzd5dmzez">
                {bonus.system && <div data-id="element-56" data-mp="3huxl1z6flpw9">
                    <p className="text-[#0B1F4D] font-semibold text-sm mb-2" data-id="element-57" data-mp="3mr5zfact1f2d">{bonus.systemLabel}</p>
                    <p className="text-[#0B1F4D] font-bold text-xs sm:text-sm tracking-wide bg-[#E5ECF8] border-l-4 border-[#F5C400] rounded-lg px-3 py-2" data-id="element-58" data-mp="3eqggf4482t82">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.result && <div className="bg-[#F3F6FC] border border-[#D2DCEC] border-l-4 border-l-[#0B1F4D] rounded-xl p-4" data-id="element-59" data-mp="3jpjlupo471gk">
                    <span className="text-[#0B1F4D] font-bold block mb-1" data-id="element-60" data-mp="1jeojnp03mb7">RESULT</span>
                    <p className="text-slate-700 text-sm" data-id="element-61" data-mp="3tos96zoh5hty">{bonus.result}</p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-[#D2DCEC]" data-id="element-62" data-mp="bcdog1py6za4">
                    {bonus.closing.map((line, lineIndex) => <p key={line} className={lineIndex === 0 ? 'text-[#0B1F4D] font-extrabold text-base tracking-wide' : 'text-[#0B1F4D] font-semibold text-sm italic'} data-id="element-63" data-mp="l878s79wrx2g" data-mpi={lineIndex}>
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function formatUsd(cents: number): string {
  return `$${(cents / 100).toFixed(2)} USD`;
}